import { Flex } from "antd";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import { createContext, useContext, useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useToken } from "../hooks/useToken";
import { TProfile } from "../models/users.model";
import { Privacy } from "../pages/privacy";
import { SignInGeneral } from "../pages/signin";
import { Terms } from "../pages/terms";
import { getUserProfile } from "../services/users.service";

export const UserContext = createContext<{
  user: User;
  profile: TProfile | undefined;
}>({
  user: {} as User,
  profile: undefined,
});

export function UserProvider({ children }: any) {
  const [user, setUser] = useState<User>();
  const [isLoading, setLoading] = useState<boolean>(true);
  const { token } = useToken();
  const [profile, setProfile] = useState<TProfile>();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), (user) => {
      if (user) {
        setUser(user);
        getUserProfile({
          onSuccess: (data) => {
            setProfile(data);

            const userLang =
              navigator.language || (navigator as any).userLanguage;
            const dateFormat = userLang.includes("en")
              ? "MM/DD/YYYY"
              : "DD/MM/YYYY";
            localStorage.setItem("dateFormat", data?.dateFormat || dateFormat);
          },
        });

        localStorage.setItem("uid", user.uid);
      } else {
        setUser(undefined);
      }

      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (isLoading) {
    return (
      <Flex
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          background: token.colorBgContainer,

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <></>
      </Flex>
    );
  }

  if (!user) {
    return (
      <UserContext.Provider value={{ user: {} as User, profile: undefined }}>
        <BrowserRouter>
          <Routes>
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
            <Route path=":pageId" element={<SignInGeneral />} />
            <Route path="*" element={<Navigate to="/signin" />} />
          </Routes>
        </BrowserRouter>
      </UserContext.Provider>
    );
  }

  return (
    <UserContext.Provider value={{ user, profile }}>
      {children}
    </UserContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(UserContext);

  return context;
}
